import { render, staticRenderFns } from "./AutomatorDataTransferPage.vue?vue&type=template&id=4d4d30ca&scoped=true&"
import script from "./AutomatorDataTransferPage.vue?vue&type=script&lang=js&"
export * from "./AutomatorDataTransferPage.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorDataTransferPage.vue?vue&type=style&index=0&id=4d4d30ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d30ca",
  null
  
)

export default component.exports